import React, { useEffect, useState } from 'react';

import Button from './Button';
import { faCheck, faCopy, faEye, faEyeSlash } from './icon';
import Icon from './icon/Icon';

interface SecretCodeBlockProps {
  secret: string;
  label?: string;
  masked?: boolean;
  copyable?: boolean;
  className?: string;
}

export const SecretCodeBlock: React.FC<SecretCodeBlockProps> = ({
  secret,
  label,
  masked = true,
  copyable = true,
  className = '',
}) => {
  const [isVisible, setIsVisible] = useState(!masked);
  const [copied, setCopied] = useState(false);
  const [copyError, setCopyError] = useState(false);

  useEffect(() => {
    if (copied) {
      const timer = setTimeout(() => setCopied(false), 2000);
      return () => clearTimeout(timer);
    }
  }, [copied]);

  useEffect(() => {
    if (copyError) {
      const timer = setTimeout(() => setCopyError(false), 2000);
      return () => clearTimeout(timer);
    }
  }, [copyError]);

  const handleCopy = async () => {
    setCopyError(false);
    try {
      await navigator.clipboard.writeText(secret);
      setCopied(true);
    } catch (err) {
      console.error('Failed to copy secret:', err);
      setCopyError(true);
    }
  };

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  const displayValue = isVisible ? secret : '•'.repeat(40);

  return (
    <div className={`secret-code-block ${className}`}>
      {label && <label className="fw-bold">{label}</label>}
      <div className="relative w-full">
        <div className="block">
          <span className="text">{displayValue}</span>
          <div className="actions">
            {masked && (
              <Button onClick={toggleVisibility} aria-label={isVisible ? 'Hide secret' : 'Show secret'}>
                {isVisible ? <Icon icon={faEyeSlash} /> : <Icon icon={faEye} />}
              </Button>
            )}
            {copyable && (
              <Button onClick={handleCopy} aria-label="Copy secret">
                {copied ? <Icon icon={faCheck} className="text-green-600" /> : <Icon icon={faCopy} />}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecretCodeBlock;
